import { render, staticRenderFns } from "./SettlementDeductionPanel.vue?vue&type=template&id=4abe4790&scoped=true"
import script from "./SettlementDeductionPanel.vue?vue&type=script&lang=js"
export * from "./SettlementDeductionPanel.vue?vue&type=script&lang=js"
import style0 from "./SettlementDeductionPanel.vue?vue&type=style&index=0&id=4abe4790&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abe4790",
  null
  
)

export default component.exports